'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var index = require('./formats/index.js');
var index$1 = require('./operations/index.js');

/**
 * Date Hook.
 */ const useDate = (config = {})=>{
    const defaultConfig = {
        locale: 'en-US'
    };
    const { locale } = {
        ...defaultConfig,
        ...config
    };
    return react.useMemo(()=>({
            subtractFromDate: index$1.subtractFromDate,
            createDateInTimezone: index$1.createDateInTimezone,
            toLuxonDateTime: index$1.toLuxonDateTime,
            date: index.date.bind(null, locale),
            days: index.days.bind(null, locale),
            months: index.months.bind(null, locale),
            relativeTime: index.relativeTime.bind(null, locale),
            dateNumeric: index.dateNumeric.bind(null)
        }), [
        locale
    ]);
};

exports.default = useDate;
exports.useDate = useDate;
//# sourceMappingURL=useDate.js.map
